<form [formGroup]="ContentAssingFileCourses">
    <ng-template matStepLabel>Contenido del Curso</ng-template>
    <fieldset class="col-12">
        <legend>
            <span>Registro</span>
        </legend>
        <div class="card">
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label>Archivo Complementario</label>
                        <select [(ngModel)]="seleted_file_type" class="form-control"
                            formControlName="asfico_in_file_type"
                            (change)="onChange($event.target.value)">
                            <option value="">Seleccionar</option>
                            <ng-container *ngFor="let parameter of parameters">
                                <option *ngIf="parameter.sys_in_group==1100" value="{{parameter.sys_in_parameter}}">
                                    {{parameter.sys_vc_description}}
                                </option>
                            </ng-container>
                        </select>
                    </div>
                    <div *ngIf="bLink" class="form-group col-md-5">
                        <label>Link</label>
                        <input type="text" class="form-control" formControlName="asfico_vc_file_name" />
                    </div>
                    <div class="form-group col-md-3">
                        <label>&nbsp;</label>
                        <button class="btn btn-badminton btn-block" (click)="Register()">Guardar</button>
                    </div>
                </div>
                <div *ngIf="!bLink" class="form-row">
                     
                    <div class="form-group col-md-4">
                        <input type="file" ng2FileSelect [uploader]="uploader">
                    </div>
                </div>

            </div>
        </div>

    </fieldset>

    <fieldset class="col-12">
        <legend>Listado</legend>
        <div class="card card-osiptel-default">
            <div class="card-body">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 col-12">
                    <ng-container matColumnDef="asfico_vc_file_type">
                        <th style="width: 65%;" mat-header-cell mat-sort-header *matHeaderCellDef>Archivo
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.asfico_vc_file_type}} </td>
                    </ng-container>
                    <ng-container matColumnDef="opcion">
                        <th style="width: 30%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                        <td mat-cell *matCellDef="let element">
                            <a class="pr-2" (click)="viewerFile(element)"><i class="fa fa-eye"></i> Ver Archivo</a>
                            <a class="pr-2" (click)="Detele(element.asfico_bi_id)"><i class="fa fa-remove"></i> Eliminar</a>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </fieldset>

    <div>
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
    </div>
</form>